
import { TargetUserCard } from "./TargetUserCard";
import { User, Briefcase, Building2, Users } from "lucide-react";

export function TargetUsersSection() {
  const targetUsers = [
    {
      title: "Freelancers",
      description: "Who need an easy way to log billable hours.",
      icon: User
    },
    {
      title: "Consultants",
      description: "Who manage multiple projects and clients.",
      icon: Briefcase
    },
    {
      title: "Agencies & Small Business Owners",
      description: "Who want clear insights into time allocation and revenue.",
      icon: Building2
    },
    {
      title: "Anyone",
      description: "Who needs a simple, accurate, and efficient way to track and manage work hours.",
      icon: Users
    }
  ];

  return (
    <section className="py-12 bg-gradient-to-b from-white to-muted/30">
      <div className="container max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">
          <span className="bg-gradient-primary text-transparent bg-clip-text">
            Who is Hour Tracker For?
          </span>
        </h2>
        
        <p className="text-center text-muted-foreground mb-8 max-w-xl mx-auto">
          Designed for professionals who value their time and want to maximize productivity
        </p>
        
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {targetUsers.map((user, index) => (
            <TargetUserCard
              key={index}
              title={user.title}
              description={user.description}
              Icon={user.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
